import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private loginService: LoginService
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    sessionStorage.clear();
  }

  onSubmit(): void {
    const { username, password } = this.loginForm.value;
    if (username && password) {
      this.loginService.login(username, password).subscribe({
        next: (response: any) => {

          const authToken = JSON.parse(response).authToken;
          const roleId = JSON.parse(response).roleId; // Add roleId to response
          sessionStorage.setItem('authToken', authToken);
          sessionStorage.setItem('roleId', roleId); // Store roleId in local storage
          this.snackBar.open(JSON.parse(response).message, 'Close', { duration: 2000 });
          this.loginService.getUserDataByUserName(username).subscribe({
            next : (res:any) => {
              console.log("Username: ", username);
              console.log("Response for getUserData by userName is: ", res);
              sessionStorage.setItem("userData",JSON.stringify(res.responseObject))
              this.router.navigate(['/home/timesheet']); // Navigate to /home route
            }
          })
        },
        error: (error: HttpErrorResponse) => {
          this.errorMessage = 'Login failed. Please try again.';
        }
      });
    } else {
      this.errorMessage = 'Invalid username or password';
    }
  }
}